<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-user" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{user.first_name}} {{user.last_name}}</div>
            <div class="meta" v-if="user.username"><i class="fas fa-at fa-fw mr-2"></i>{{user.username}}</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <div class="stat">
                    <i class="fas fa-person-chalkboard" v-if="user.content_provider_id"></i>
                    <i class="fas fa-memo-circle-check ml-2" v-if="user.is_approval_committee"></i>
                </div>
            </div>
        </template>
        <template v-slot:details>
            <div class="tile-details">
                <toolbar class="toolbar" v-if="currentUser.isSuper && currentUser.id !== user.id">
                    <b-tooltip v-if="currentUser.isSuper && currentUser.id !== user.id" label="Portal Login"><button class="icon-only" @click="switchAndRedirect(user.id)"><i class="far fa-circle-user"></i></button></b-tooltip>
                </toolbar>

                <div class="data mt-1">
                    <data-row mini title="ID">{{user.id}}</data-row>
                    <data-row mini title="247 ID">{{user.id_247 || 'N/A'}}</data-row>
                    <data-row mini title="Approval Committee">{{user.is_org_admin ? 'Yes' : 'No'}}</data-row>
                    <data-row mini title="Admin">{{user.is_org_admin ? 'Yes' : 'No'}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'PortalUserTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            user: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false
            }
        },
        computed: {
            ...mapGetters(['currentUser']),
        },
        methods: {
            ...mapActions(['switchUser']),
            switchAndRedirect: function(portalId) {
                if (!this.currentUser.isSuper) return;
                this.switchUser({ portal_id: portalId }).then(() => {
                    this.$resetCards();
                });
            },
            login: function () {
                this.$emit('login');
            },
            openCard: function (card, props) {
                this.$openCard(card, props, this.card);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .tile-details {
        margin-top: 0.5rem;
    }
</style>
